import { useState } from 'react';
import { Link } from 'react-router-dom';
import WhatsAppForm from './WhatsAppForm';

function Dashboard() {
  const [activeMenu, setActiveMenu] = useState('whatsapp');

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-lg p-6">
        <h1 className="text-xl font-bold mb-6 flex items-center text-green-700">
          <span className="mr-2">💬</span> WhatsApp Sender
        </h1>
        <div className="space-y-4">
          <button
            className={`w-full text-left p-2 rounded ${
              activeMenu === 'whatsapp' ? 'bg-gray-200' : 'hover:bg-gray-100'
            } flex items-center`}
            onClick={() => setActiveMenu('whatsapp')}
          >
            <span className="mr-2">💬</span> WhatsApp Message
          </button>
        </div>
      </div>
      {/* Main Content */}
      <div className="flex-1 p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-semibold">Fill out the form below to send a WhatsApp message</h2>
          <div className="flex items-center">
            <Link
              to="/"
              className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
              onClick={() => {
                localStorage.removeItem('token');
              }}
            >
              Logout
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-1 bg-white p-4 rounded shadow">
            {activeMenu === 'whatsapp' && <WhatsAppForm />}
          </div>
          <div className="col-span-1 bg-white p-4 rounded shadow">
            <h3 className="text-md font-semibold mb-4 flex items-center text-green-700">
              <span className="mr-2">💡</span> Tips for sending messages
            </h3>
            <ul className="text-gray-600 space-y-2">
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✔</span> Always include your country code with the phone number
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✔</span> Keep messages concise and clear
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✔</span> Avoid sending too many messages at once
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✔</span> Respect users' privacy and comply with local regulations
              </li>
            </ul>
          </div>
          <div className="col-span-1 bg-white p-4 rounded shadow">
            <h3 className="text-md font-semibold mb-4 flex items-center text-green-700">
              <span className="mr-2">📝</span> Message Preview
            </h3>
            <div className="bg-gray-100 p-3 rounded text-gray-500">
              Your message will appear here
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;